import { LucideIcon } from 'lucide-react';

interface IconActionButtonProps {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
  href?: string;
  danger?: boolean;
  disabled?: boolean;
}

/**
 * The shared icon-action-tile pattern for row/detail-page actions
 * (View/Print/Edit/Delete-style actions) - one real component so
 * every page renders this identically. The label shows only as a
 * hover/focus tooltip, not permanently under the icon - a real,
 * deliberate choice so rows with several actions stay compact. A
 * real aria-label is still always present so the button remains
 * genuinely accessible even though the text is visually hidden
 * until hover.
 */
export function IconActionButton({ icon: Icon, label, onClick, href, danger, disabled }: IconActionButtonProps) {
  const tileClass = danger ? 'icon-action-tile icon-action-tile-danger' : 'icon-action-tile';

  if (href) {
    return (
      <a className="icon-action" href={href} target="_blank" rel="noreferrer" aria-label={label}>
        <span className={tileClass}><Icon size={20} /></span>
        <span className="icon-action-label">{label}</span>
      </a>
    );
  }

  return (
    <button type="button" className="icon-action" onClick={onClick} disabled={disabled} aria-label={label}>
      <span className={tileClass}><Icon size={20} /></span>
      <span className="icon-action-label">{label}</span>
    </button>
  );
}
